module.exports = __webpack_public_path__ + "static/media/loader-button.0cfc308d.gif";